import FetchClient from "./FetchClient";
import type { ApiResponse } from "./ProductsService";

export interface Deal {
  dealId: string;
  upc: string;
  sku: string;
  name: string;
  msrp: number;
  onlinePrice: number;
  storePrice: number;
  image: string;
  storeId: string;
  retailer: string;
  category: string;
  url: string;
  aisle: string;
  inStock: boolean;
  discountPercentage: number;
  createdAt: number;
  createdBy: string;
  productKey?: string;
}

export interface CreateDealRequest {
  upc: string;
  sku: string;
  name: string;
  msrp: number;
  onlinePrice: number;
  storePrice: number;
  image: string;
  storeId: string;
  retailer: string;
  category: string;
  url: string;
  aisle: string;
  inStock: boolean;
  discountPercentage: number;
}

export async function createDeal(req: CreateDealRequest): Promise<string> {
  const response = await FetchClient.post<ApiResponse<{ dealId: string }>>(
    "/deals",
    req
  );
  return response.data.dealId;
}

export async function getPublicDeal(dealId: string): Promise<Deal> {
  const response = await FetchClient.get<ApiResponse<Deal>>(
    `/public/deals/${encodeURIComponent(dealId)}`,
    {},
    "optional"
  );
  return response.data;
}

export function getDealShareUrl(dealId: string): string {
  const apiBase = (import.meta.env.VITE_API_URL || window.location.origin).replace(/\/$/, "");
  return `${apiBase}/d/${encodeURIComponent(dealId)}`;
}
